import Tooltip from './tooltip';

function tooltip(props) {
  return new Tooltip(props);
}

export default tooltip;


//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/tooltip/index.js
// module id = 575
// module chunks = 9